export const isNumeric = (str: string | null | undefined) => {
  if (str === null || str === undefined) {
    return false;
  }

  return !isNaN(parseFloat(str));
};
